import { orderBy } from 'lodash';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect, useCallback, useState, useRef, useMemo } from 'react';
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { Box, Grid, Button, Skeleton, Container, Stack,Checkbox, ListItemText, Popover, Tabs, Tab, Typography, Menu, MenuItem, OutlinedInput, InputAdornment, Badge, TextField, FormHelperText, ButtonGroup, Divider, List, TablePagination, Tooltip, IconButton, Chip } from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getPostsInitial, getMorePosts } from '../../redux/slices/blog';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { BlogPostCard, BlogPostsSort, BlogPostsSearch } from '../../components/_dashboard/blog';
import { UserCard } from 'src/components/_dashboard/user/cards';
import AddProject from 'src/components/_dashboard/blog/AddProject';
import { capitalCase } from 'change-case';
import { MButton } from 'src/components/@material-extend';
import { Visibility, VisibilityOff, List as ListIcon,ViewList, ViewModule, ExpandMore, ExpandLess, Settings, FilterList, Delete } from '@material-ui/icons';
import ProductionControll from 'src/components/_dashboard/blog/ProductionControl';
import ProjectGrid from 'src/components/_dashboard/blog/ProjectGridList';
import ProjectList from 'src/components/_dashboard/blog/ProjectListView';
import axios from 'axios';
import { COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import useWorkSpaceOption from 'src/hooks/useWorkspaceOptions';
import { MobileDateRangePicker } from '@material-ui/lab';
import { cancelAllGlobalRequests } from 'src/utils/globalApiCancellationManager';
import moment from 'moment';
import Scrollbar from 'src/components/Scrollbar'
import ProductionControllForEstimate from 'src/components/_dashboard/blog/ProductionControllForEstimate';
// ----------------------------------------------------------------------

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

const applySort = (posts, sortBy) => {
  if (sortBy === 'latest') {
    return orderBy(posts, ['createdAt'], ['desc']);
  }
  if (sortBy === 'oldest') {
    return orderBy(posts, ['createdAt'], ['asc']);
  }
  if (sortBy === 'popular') {
    return orderBy(posts, ['view'], ['desc']);
  }
  return posts;
};

const SkeletonLoad = (
  <Grid container spacing={3} sx={{ mt: 2 }}>
    {[...Array(4)].map((_, index) => (
      <Grid item xs={12} md={3} key={index}>
        <Skeleton variant="rectangular" width="100%" sx={{ height: 200, borderRadius: 2 }} />
        <Box sx={{ display: 'flex', mt: 1.5 }}>
          <Skeleton variant="circular" sx={{ width: 40, height: 40 }} />
          <Skeleton variant="text" sx={{ mx: 1, flexGrow: 1 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);
//  
const SORT = [
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
  { id: 'new', label: 'Newest', color: '#54D62C' }, 
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
];

export default function EstimateJobs() {
  const theme = useTheme()
  const { workSpaceTitle } = useWorkSpaceOption()
  const locationState = useLocation()
  const newTab = locationState.state?.newTab
  const ref = useRef(null);
  const refcategory = useRef(null);
  const dispatch = useDispatch();
  const [types,setTypes]  = useState([])
  const [categories,setCategories]  = useState([])
  const [selectedJobClassIdsString, setSelectedJobClassIdsString] = useState('')
  const [selectedJobTypesIdsString, setSelectedJobTypesIdsString] = useState('')
  const [filters, setFilters] = useState('latest');
  const [filterName, setFilterName] = useState('');
  const [currentTab, setCurrentTab] = useState(newTab || 'New');
  const [renderCards, setRenderCards] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [add,setAdd] = useState(false)
  const [isEdit,setIsEdit] = useState(false)
  const [all,setAll] = useState(false)
  const [openType,setOpenType] = useState(false)
  const [openCategory,setOpencategory] = useState(false)
  
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const debounceTimeoutRef = useRef(null);
  const [data,setData] = useState([])
  const [singleProjectData,setSingleProjectData] = useState(null)
  const [filtered,setFiltered] = useState([])
  const [searchData,setSearchData] = useState([])
  const { posts, hasMore, index, step } = useSelector((state) => state.blog);
  const sortedPosts = applySort(posts, filters);
  const onScroll = useCallback(() => dispatch(getMorePosts()), [dispatch]);
  const [productionCount,setProductionCount] = useState(0)
  const [holdCount,setHoldCount] = useState(0)
  const [rejectedCount,setRejectedCount] = useState(0)
  const [voidCount, setVoidCount] = useState(0)
  const [preCount,setPreCount] = useState(0)
  const [postCount,setPostCount] = useState(0)
  const [draftCount,setDraftCount] = useState(0)
  const [filteredInstallations,setFilteredInstallations] = useState([])
  const [completedCount,setCompletedCount] = useState(0)
  const [awaitingManagerCount, setAwaitingManagerCount] = useState(0)
  const [installsCount,setInstallsCount] = useState(0)
  const [shippingCount,setShippingCount] = useState(0)
  const [pickupCount,setPickupCount] = useState(0)
  const [filteredPickup,setFilteredPickup] = useState([])
  const [filteredShipping,setFilteredShipping] = useState([])
  const [filteredCompletedInstallations,setFilteredCompletedInstallations] = useState([])
  const [filteredReviewInstallations,setFilteredReviewInstallations] = useState([])
  const [value, setValue] = useState('one');
  console.log('value----1244567897654', value)
  const [isNewRowIdPresent,setIsNewRowIdPresent] = useState([])
  const refCommunities = useRef(null);
  const refDepartments = useRef(null);
  const refClients = useRef(null);
  const refUsers = useRef(null);
  const [communitiesOpen, setCommunitiesOpen] = useState(false);
  const [departmentsOpen, setDepartmentsOpen] = useState(false);
  const [clientOpen, setClientOpen] = useState(false);
  const [usersOpen, setUsersOpen] = useState(false);
  const [communitiesData, setCommunitiesData] = useState([]);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [filterDepartment, setFilterDepartment] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [filterCommunity, setFilterCommunity] = useState([]);
  const [filterClient, setFilterClient] = useState([]);
  const [filterUser, setFilterUser] = useState([]);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [projectSearchTerm, setProjectSearchTerm] = useState('');
  const [departmentSearchTerm, setDepartmentSearchTerm] = useState('');
  const [jobClassSearchTerm, setJobClassSearchTerm] = useState('');
  const [jobTypesSearchTerm, setJobTypesSearchTerm] = useState('');
  const [installations,setInstallations]=useState([])
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');

  const [sortOpen, setSortOpen] = useState(false);
  const refSort = useRef(null);
  const [sort,setSort]=  useState(SORT[1])
  const [filterDateValue,setFilterDateValue]=  useState([null, null]);
  const [dueData,setDueData] = useState(true)
  const openPopupTemp=localStorage.getItem("openProductionPopup")
  console.log('openPopupTemp===',openPopupTemp)
  const [openViewPage, setOpenViewPage] = useState(openPopupTemp||false);
  const [projectId, setProjectId] = useState('');
  const [projectName,setProjectName]=useState('')
  const [filterProjectType, setFilterProjectType] = useState('ALL');
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [isDeletingFilters, setIsDeletingFilters] = useState(false);
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const didRunInitialFiltersSyncRef = useRef(false);
  const refSettings = useRef(null);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  const isFiltersOpen = Boolean(filtersAnchorEl);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const removePopupData=()=>{
    setProjectId('');
    setProjectName('');
  }

  const  user  = JSON.parse(window.localStorage.getItem('user'))
  const userId = user?.user_id || user?.id;
  const explodedPermissions = user?.exploded_permissions
  const hasPermission = explodedPermissions?.some((permission) =>
    ['View Estimate Jobs', 'Hold Estimate Jobs', 'Manage Estimate Job Cost'].includes(permission)
  )
    ? true
    : false
  const viewasadmin = explodedPermissions?.some((permission) => ['View Estimate Job as Admin'].includes(permission)) ? true : false
  // Debounced search effect
  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); // 500ms delay
    
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  const memoizedFilteredData = useMemo(() => {
    return data.filter((item) => {
      // const nameMatch = filterName ? item.name.toLowerCase().includes(filterName.toLowerCase()) : true;
      // const nameMatch = filterName ? (item.name?.toLowerCase().includes(filterName.toLowerCase()) || item.description?.toLowerCase().includes(filterName.toLowerCase())) : true;
      const nameMatch = filterName
      ? (
          item.description?.toLowerCase().includes(filterName.toLowerCase()) ||
          item.customer_name?.toLowerCase().includes(filterName.toLowerCase()) ||
          item.name?.toLowerCase().includes(filterName.toLowerCase()) ||
          item.job_category_name?.toLowerCase().includes(filterName.toLowerCase()) ||
          item.job_class_name?.toLowerCase().includes(filterName.toLowerCase()) ||
          item.community_name?.toLowerCase().includes(filterName.toLowerCase()) ||
          item.doc_number?.toLowerCase().includes(filterName.toLowerCase()) ||
          item?.est_doc_number?.toLowerCase().includes(filterName.toLowerCase())
        )
      : true;
      const categoryMatch = categories.some((c) => c.checked) ? categories.filter((c) => c.checked).map((c) => c.id).includes(item.project_category) : true;
      return nameMatch && categoryMatch;
    });
  }, [data, filterName, categories]);

  useEffect(() => {
    setSearchData(memoizedFilteredData);
  }, [memoizedFilteredData]);

  // NEW OPTIMIZED: Separate function to fetch filter data only once
  const fetchFilterData = async () => {
    try {
      const filterResponse = await axios.post(
        `${REST_API_END_POINT}project/get-project-filter-data`,
        {
          userType: { value: viewasadmin ? 1 : user.user_type },
          userId: { value: user.user_id },
          hasPermission
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      // Process communities data
      const fetchedCommunities = (filterResponse?.data?.community || []).map(
        (community) => ({
          ...community,
          // BACKUP: Original community count logic - commented out for backup
          // no_of_projects: (community.no_of_projects || 0) + (installationCounts[community.id] || 0)
        })
      );
      const othersCommunity = { id: 'other', name: 'Others' };
      fetchedCommunities.push(othersCommunity);

      setCommunitiesData((oldCommunities) =>
        fetchedCommunities.map((comm) => {
          const old = oldCommunities.find((o) => o.id === comm.id);
          return {
            ...comm,
            checked: old ? old.checked : false
          };
        })
      );

       //Departments
       let fetchedDepartments = (filterResponse?.data?.departments || [])
       const othersDepartment = { id: 'All', name: 'All' };
       // fetchedDepartments.unshift(othersDepartment);
       setDepartmentsData((oldDepartments) =>
         fetchedDepartments.map((dep) => {
           const old = oldDepartments.find((o) => o.id === dep.id);
           return {
             ...dep,
             checked: old ? old.checked : false
           };
         })
       );

      // Process clients data
      const fetchedClients = filterResponse?.data?.clients || [];
      setClientData((oldClients) =>
        fetchedClients.map((client) => {
          const old = oldClients.find((o) => o.id === client.id);
          return {
            ...client,
            checked: old ? old.checked : false
          };
        })
      );

      // Process user data
      const fetchedUsers = filterResponse.data.staffMembers || [];
      setUserData((oldUsers) =>
        fetchedUsers.map((user) => {
          const old = oldUsers.find((o) => o.id === user.id);
          return {
            ...user,
            checked: old ? old.checked : false
          };
        })
      );
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('fetchFilterData cancelled');
        return;
      }
      console.error('Error fetching filter data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!filtersInitialized) return;
      if (isDeletingFilters) return;
      setIsLoading(true);
      try {
        const fromDate = filterDateValue[0]
          ? moment(filterDateValue[0])?.format('YYYY-MM-DD')
          : null;
        const toDate = filterDateValue[1]
          ? moment(filterDateValue[1])?.format('YYYY-MM-DD')
          : null;
    
        // Fetch only main project data (results, completedInstallations, pagination)
        const projectResponse = await axios.post(
          `${REST_API_END_POINT}project/get-all-estimate-projects`,
          {
            userType: { value: viewasadmin ? 1 : user.user_type },
            userId: { value: user.user_id },
            hasPermission,
            sort: sort.id,
            from: fromDate,
            to: toDate,
            dueData: false,
            filterProjectType: filterProjectType,
            currentTab: all ? 'ALL' : currentTab,
            page: page + 1, // Backend uses 1-based pagination
            limit: rowsPerPage,
            search: debouncedSearchTerm,
            jobClassFilter: selectedJobClassIdsString ? selectedJobClassIdsString.split(',').map(id => parseInt(id)) : [],
            jobTypesFilter: selectedJobTypesIdsString ? selectedJobTypesIdsString.split(',').map(id => parseInt(id)) : [],
            clientFilter: filterClient.length > 0 ? filterClient.map(id => parseInt(id)) : [],
            userFilter: filterUser.length > 0 ? filterUser.map(id => parseInt(id)) : [],
            projectFilter: filterCommunity.length > 0 ? filterCommunity.map(id => id === 'other' ? 'other' : parseInt(id)) : [],
            departmentFilter: filterDepartment.length > 0 ? filterDepartment.map(id => parseInt(id)) : []
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        const completedInstallations = projectResponse?.data?.completedInstallations || [];
        // const pagination = projectResponse?.data?.pagination || {};
        
        // COMMENTED OUT: Count fetched from separate endpoint
        // setTotalCount(pagination.totalCount || 0);
        
        const installationCounts = completedInstallations.reduce((acc, installation) => {
          acc[installation.community] = (acc[installation.community] || 0) + 1;
          return acc;
        }, {});
        const installationClientCount = completedInstallations.reduce((acc, installation) => {
          acc[installation.customer_id] = (acc[installation.customer_id] || 0) + 1;
          return acc;
        }, {});
    
        const filteredProject = projectResponse.data.results;
    
        // Count projects per community, excluding "Post Production"
        // Only update communities if no filters are applied to avoid filtered results
        if (filterCommunity.length === 0 && filterClient.length === 0 && filterUser.length === 0 && filterDepartment.length === 0) {
          const fetchedCommunities = (projectResponse?.data?.community || []).map(
            (community) => ({
              ...community,
              // no_of_projects: filteredProject.filter(
              //   (project) => project.community === community.id
              // ).length + (installationCounts[community.id] || 0),
            })
          );
          const othersCommunity = { id: 'other', name: 'Others' };
          fetchedCommunities.push(othersCommunity);

          setCommunitiesData((oldCommunities) =>
            fetchedCommunities.map((comm) => {
              const old = oldCommunities.find((o) => o.id === comm.id);
              return {
                ...comm,
                checked: old ? old.checked : false
              };
            })
          );
        }
      
         // Update client data with project counts (only if clients already exist)
        if (clientData.length > 0) {
          setClientData((oldClients) =>
            oldClients.map((client) => ({
              ...client,
              no_of_projects: filteredProject.filter(
                (project) => project.customer_id === client.id
              ).length,
            }))
          );
        }

        // Process user data - only update if no filters are applied to avoid filtered results
        if (filterCommunity.length === 0 && filterClient.length === 0 && filterUser.length === 0 && filterDepartment.length === 0) {
          const fetchedUsers = projectResponse.data.staffMembers || [];
          setUserData((oldUsers) =>
            fetchedUsers.map((user) => {
              const old = oldUsers.find((o) => o.id === user.id);
              return {
                ...user,
                checked: old ? old.checked : false
              };
            })
          );
        }
        
    
        const projects = projectResponse.data.results || [];
        const filteredProjects = projects.filter(
          (item) => (item.status === 1 || item.status === 0) && item.jobcost === 0
        );
        const draftCountValue = projects.filter(
          (project) => project?.is_draft === 1 || project?.is_draft === '1'
        ).length;
        setDraftCount(draftCountValue);
    
        // Set counts for tabs
        const counts = {
          'In Progress': 0,
          'New': 0,
          'NO SERVICE NO TASK': 0,
          Hold: 0,
          Rejected: 0,
        };
    
        projects.forEach((item) => {
          const isRejectedJob =
            item.is_rejected === 1 ||
            item.is_rejected === '1' ||
            Number(item.quotation_status) === 6 ||
            Number(item.quotation_status) === 11;
          if (isRejectedJob) counts['Rejected'] += 1;
          else if (item.hold === 1) counts['Hold'] += 1;
          else if (item.status === 3 && item.hold === 0 && item?.noServiceNoTask == 1 ) counts['NO SERVICE NO TASK'] += 1;
          else if ((item.status === 1 || item.status === 0) && item.hold === 0)
            counts['New'] += 1;
          else if (item.status !== 1 && item.status !== 3 && item.status !== 0 && item.hold === 0)
            counts['In Progress'] += 1;
        });

        setRejectedCount(counts['Rejected'] || 0);

    
        const sortedByDueDate = dueData
          ? projects?.sort((a, b) => new Date(a.installation_date) - new Date(b.installation_date))
          : projects;

        setData(sortedByDueDate);
        const useBackendTabResults =
          all ||
          currentTab === 'Void' ||
          currentTab === 'Rejected' ||
          currentTab === 'Completed' ||
          currentTab === 'Drafts' ||
          currentTab === 'Hold';
        const displayProjects = useBackendTabResults ? projects : filteredProjects;
        setFiltered(displayProjects);
        setSearchData(displayProjects);
        setInstallations(completedInstallations);
    
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('fetchData cancelled');
          return;
        }
        console.error('Error fetching data:', error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    };
    fetchData();
  }, [filtersInitialized, isDeletingFilters, renderCards, dueData, sort, filterDateValue, currentTab, page, rowsPerPage, debouncedSearchTerm, filterProjectType, selectedJobClassIdsString, selectedJobTypesIdsString, filterClient, filterUser, filterCommunity, all, filterDepartment]);

  // NEW OPTIMIZED: Load filter data only once when component mounts
  useEffect(() => {
    fetchFilterData();
  }, []); // Run once on mount

  // NEW OPTIMIZED: Separate function to fetch count
  const fetchProjectsCount = async () => {
    try {
      const fromDate = filterDateValue[0]
        ? moment(filterDateValue[0])?.format('YYYY-MM-DD')
        : null;
      const toDate = filterDateValue[1]
        ? moment(filterDateValue[1])?.format('YYYY-MM-DD')
        : null;
  
      const countResponse = await axios.post(
        `${REST_API_END_POINT}project/get-all-estimate-projects-count`,
        {
          userType: { value: viewasadmin ? 1 : user.user_type },
          userId: { value: user.user_id },
          hasPermission,
          sort: sort.id,
          from: fromDate,
          to: toDate,
          dueData: false,
          filterProjectType: filterProjectType,
          currentTab: all ? 'ALL' : currentTab,
          limit: rowsPerPage,
          search: debouncedSearchTerm,
          jobClassFilter: selectedJobClassIdsString ? selectedJobClassIdsString.split(',').map(id => parseInt(id)) : [],
          jobTypesFilter: selectedJobTypesIdsString ? selectedJobTypesIdsString.split(',').map(id => parseInt(id)) : [],
          clientFilter: filterClient.length > 0 ? filterClient.map(id => parseInt(id)) : [],
          userFilter: filterUser.length > 0 ? filterUser.map(id => parseInt(id)) : [],
          projectFilter: filterCommunity.length > 0 ? filterCommunity.map(id => id === 'other' ? 'other' : parseInt(id)) : [],
          departmentFilter: filterDepartment.length > 0 ? filterDepartment.map(id => parseInt(id)) : []
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (countResponse.data?.status === 1) {
        const pagination = countResponse.data?.pagination || {};
        setTotalCount(pagination.totalCount || 0);
        if (currentTab === 'Void') {
          setVoidCount(pagination.totalCount || 0);
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('fetchProjectsCount cancelled');
        return;
      }
      console.error('Error fetching count:', error);
    }
  };

  // NEW OPTIMIZED: Fetch count when filters change (but not on page change)
  useEffect(() => {
    if (!filtersInitialized) return;
    if (isDeletingFilters) return;
    fetchProjectsCount();
  }, [filtersInitialized, isDeletingFilters, renderCards, dueData, sort, filterDateValue, currentTab, rowsPerPage, debouncedSearchTerm, filterProjectType, selectedJobClassIdsString, selectedJobTypesIdsString, filterClient, filterUser, filterCommunity, all, filterDepartment]);

  // const fetchJobsCount = async () => {
  //     try {
  //       let userId = user?.user_id;
  //       const response = await axios.post(`${REST_API_END_POINT}jobs/jobs-tabs-count`, { userId });
  //       if (response?.data?.status === 1) {

  //         const { 
  //           hold_count_ids = [], pre_production_count_ids = [], 
  //           production_count_ids = [], installs_count_ids = [], 
  //           pickup_count_ids = [], shipping_count_ids = [], 
  //            completed_count_ids = []
  //         } = response.data?.data;

  //         const validHoldCountIds = hold_count_ids ? hold_count_ids.split(',') : [];
  //         const validPreProductionCountIds = pre_production_count_ids ? pre_production_count_ids.split(',') : [];
  //         const validInProductionCountIds = production_count_ids ? production_count_ids.split(',') : [];
  //         const validInstallsCountIds = installs_count_ids ? installs_count_ids.split(',') : [];
  //         const validPickupCountIds = pickup_count_ids ? pickup_count_ids.split(',') : [];
  //         const validShippingCountIds = shipping_count_ids ? shipping_count_ids.split(',') : [];
  //         const validCompletedCountIds = completed_count_ids ? completed_count_ids.split(',') : [];
    
  //         const allIds = [
  //           ...validHoldCountIds, ...validPreProductionCountIds, ...validInProductionCountIds,
  //           ...validInstallsCountIds, ...validPickupCountIds, ...validShippingCountIds, ...validCompletedCountIds
  //         ];
    
  //         const uniqueIds = [...new Set(allIds)];
    
  //         const commaSeparatedIds = uniqueIds.join(',');
    
  //         setIsNewRowIdPresent(commaSeparatedIds);
  //         console.log('commaSeparatedIds', commaSeparatedIds)
  //       } else {
  //         console.warn("Failed to fetch Jobs counts:", response?.data?.message);
  //       }
  //     } catch (error) {
  //       if (axios.isCancel(error)) {
  //         console.log('fetchJobsCount cancelled');
  //         return;
  //       }
  //       console.error("Error fetching Jobs counts:", error);
  //     }
  //   };  
  //   useEffect(async()=>{
  //     fetchJobsCount()
  //   },[renderCards, sort,dueData,currentTab, filterDateValue, filterProjectType])

  useEffect(() => {
    if (data && installations) { 
      // Comprehensive filtering for all data
      const filteredByFilters = data.filter(item => {
        const clientMatch = filterClient.length === 0 ||
          filterClient.includes(item.customer_id) ||
          (item.customer_id === null && filterClient.includes('other'))

        const categoryMatch = categories.some(cat => cat.checked) 
          ? categories.filter(cat => cat.checked).map(cat => cat.id).includes(item.project_category) 
          : true;
  
          const nameMatch = filterName
          ? (
              item.description?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.customer_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.job_category_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.job_class_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.community_name?.toLowerCase().includes(filterName.toLowerCase()) ||
              item.doc_number?.toLowerCase().includes(filterName.toLowerCase()) || 
              item?.est_doc_number?.toLowerCase().includes(filterName.toLowerCase())
            )
          : true;        
  
        return categoryMatch && nameMatch && clientMatch; // Removed communityMatch
       
      });
        const sortedByDueDate = dueData
        ? filteredByFilters.sort((a, b) => new Date(a.installation_date) - new Date(b.installation_date))
        : filteredByFilters;

      const filteredInstallationsByCommunity = installations.filter(item =>{

        const communityMatch = true; // Remove community filtering since it's handled by backend

        const clientMatch = filterClient.length === 0 ||
        filterClient.includes(item.customer_id) ||
        (item.customer_id === null && filterClient.includes('other'))

        // Remove userMatch - backend already filters by user, and project_members is not in response
        // const userMatch = filterUser.length === 0 ||
        //   (item.project_members && item.project_members.some(member => 
        //     filterUser.includes(member.staff_id)
        //   ));

        const categoryMatch = categories.some(cat => cat.checked) 
          ? categories.filter(cat => cat.checked).map(cat => cat.id).includes(item.project_category) 
          : true;

        const nameMatch = filterName
        ? (
            item.description?.toLowerCase().includes(filterName.toLowerCase()) ||
            item.name?.toLowerCase().includes(filterName.toLowerCase()) ||
            item.customer_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            item.job_category_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            item.job_class_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            item.community_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            item.doc_number?.toLowerCase().includes(filterName.toLowerCase()) ||
            item?.est_doc_number?.toLowerCase().includes(filterName.toLowerCase())
          )
        : true;

        return communityMatch && categoryMatch && nameMatch && clientMatch;
    });
          const sortedByDueDated = dueData
        ? filteredInstallationsByCommunity.sort((a, b) => new Date(a.installation_date) - new Date(b.installation_date))
        : filteredInstallationsByCommunity;
  
      // const sortedByDueDated = filteredInstallationsByCommunity
      console.log('sortedByDueDated 1', sortedByDueDated)
      console.log('sortedByDueDate 2', sortedByDueDate)

      // For remaining tabs, data is already filtered by backend
      const installationsTabData = sortedByDueDated;
      const pickupTabData = sortedByDueDated;
      const shippingTabData = sortedByDueDated;
      const completedTabData = sortedByDueDated;
      const reviewTabData = sortedByDueDated;
      const costCardTabData = sortedByDueDated;
      
      setFiltered(sortedByDueDate);
      

      // Set installations and completed installations data
      setFilteredInstallations(installationsTabData);
      setFilteredPickup(pickupTabData);
      setFilteredShipping(shippingTabData);
      setFilteredCompletedInstallations(completedTabData);
      setFilteredReviewInstallations(reviewTabData);
  
      setSearchData(sortedByDueDate);
      
    }
  }, [currentTab, data, filterCommunity, filterClient, filterUser, installations, categories, filterName,dueData, filterProjectType]);
  
  
  console.log('setFiltered----------',filtered);

  useEffect(() => {
    const noSearchText = !filterName || filterName.trim() === '';
    const noTypes = !types.some((t) => t.checked);
    const noCategories = !categories.some((c) => c.checked);
    const noCommunities = filterCommunity.length === 0;
    const noClients = filterClient.length === 0;
    const noUsers = filterUser.length === 0;
  
    if (noSearchText && noTypes && noCategories && noCommunities && noClients && noUsers) {
      // No filters -> show all filtered data
      setSearchData(filtered); 
      return; // Prevent further execution
    }
  
    const newData = filtered.filter((p) => {
      const nameMatch = filterName
        ? (
            p.name?.toLowerCase().includes(filterName.toLowerCase()) ||
            p.description?.toLowerCase().includes(filterName.toLowerCase()) ||
            p.customer_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            p.job_category_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            p.job_class_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            p.community_name?.toLowerCase().includes(filterName.toLowerCase()) ||
            p.doc_number?.toLowerCase().includes(filterName.toLowerCase()) ||
            p?.est_doc_number?.toLowerCase().includes(filterName.toLowerCase())
          )
        : true;

      const activeTypes = types
        .filter((t) => t.checked)
        .map((t) => Number(t.id));
      const typeMatch = activeTypes.length > 0
        ? activeTypes.includes(Number(p.project_type))
        : true;
      const activeCategories = categories
        .filter((c) => c.checked)
        .map((c) => Number(c.id));
      const categoryMatch = activeCategories.length > 0
        ? activeCategories.includes(Number(p.project_category))
        : true;
      const communityMatch = true; // Remove community filtering since it's handled by backend

      const clientMatch = filterClient.length === 0 ||
      filterClient.includes(p.customer_id) ||
        (filterClient.includes('other') && (p.customer_id === null || p.customer_id === 'other'));
  
      // Remove userMatch - backend already filters by user, and project_members is not in response
      // const userMatch = filterUser.length === 0 ||
      //   (p.project_members && p.project_members.some(member => 
      //     filterUser.includes(member.staff_id)
      //   ));

      return nameMatch && typeMatch && categoryMatch && communityMatch && clientMatch;
    });
  
    setSearchData((prevSearchData) => {
      // Avoid unnecessary updates
      if (JSON.stringify(prevSearchData) === JSON.stringify(newData)) {
        return prevSearchData;
      }
      return newData;
    });
  }, [filterName, filtered, categories, filterCommunity, filterClient, filterUser]);
  

   const handleFetchEditData = useCallback((id) => {
    try {
      const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/get-project-by-id`,{ id: { value: id}, userId:user.user_id, userType: user.user_type  },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setSingleProjectData(response.data)
      
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }, [isEdit]);

  const draftProjects = useMemo(
    () =>
      searchData.filter(
        (project) => project?.is_draft === 1 || project?.is_draft === '1'
      ),
    [searchData]
  );

  const nonDraftProjects = useMemo(
    () =>
      searchData.filter(
        (project) => !(project?.is_draft === 1 || project?.is_draft === '1')
      ),
    [searchData]
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const ACCOUNT_TABS = [
   
    {
      value: 'Hold',
      count:holdCount||0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={searchData} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} isEstimateJobOnly={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'New',
      count:preCount||0,
    component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={nonDraftProjects} isNewRowIdPresent={isNewRowIdPresent}/>,
    listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={nonDraftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={nonDraftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'In Progress',
      count:productionCount||0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/great.png'} projectData={nonDraftProjects} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/great.png'} projectData={nonDraftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData}  projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/great.png'} projectData={nonDraftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'Awaiting Manager Approval',
      label: 'Manager Approval',
      count: awaitingManagerCount || 0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'https://signwisesolutions.com/uploads/ranks/regular.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'Completed',
      count:completedCount||0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={nonDraftProjects} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={nonDraftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={nonDraftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'Drafts',
      count:draftCount||0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={draftProjects} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={draftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/super.png'} projectData={draftProjects} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'Rejected',
      count: rejectedCount || 0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={searchData} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
    {
      value: 'Void',
      count: voidCount || 0,
      component:<ProductionControllForEstimate removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={searchData} isNewRowIdPresent={isNewRowIdPresent}/>,
      listComponent:<ProjectList isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
      GridListComponent:<ProjectGrid isEstimateJob={true} removePopupData={removePopupData} projectId={projectId} setProjectId={setProjectId}openViewPage={openViewPage} setOpenViewPage={setOpenViewPage}projectName={projectName} setProjectName={setProjectName} isLoading={isLoading} setRenderCards={setRenderCards} renderCards={renderCards} setIsEdit={setIsEdit} handleFetchEditData={handleFetchEditData} currentTab={currentTab} medal={'/static/icons/regular.png'} projectData={searchData} totalCount={totalCount} mainPage={page} mainRowsPerPage={rowsPerPage} changePage={handleChangePage} changeRowsPerPage={handleChangeRowsPerPage} rowsPerPageOptions={[25, 50, 100, 500]}/>,
    },
  ];
  

  useEffect(() => {
    dispatch(getPostsInitial(index, step));
  }, [dispatch, index, step]);

  const handleChangeSort = (event) => {
    setFilters(event.target.value);
  };
  const handleClick =()=>{
    setAll(!all)
    localStorage.setItem('all_project',all)
    setFilterUser([])
    setFilterClient([])
    setFilterCommunity([])
  }
  const handleChangeTab = (event, newValue) => {
    // Cancel all active requests when switching tabs
    cancelAllGlobalRequests(`Tab switch to ${newValue}`);
    
    if (newValue === 'Completed' || newValue === 'Awaiting Manager Approval') {
      setDueData(false);
    } else {
      setDueData(true);
    }
    setProjectId("");
    setProjectName("");
    setCurrentTab(newValue);
    // setRenderCards(!renderCards);
    // setFilterName('');
  };
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const CustomTab = styled(Tab)(({ theme }) => ({
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    boxShadow: 'none', //theme.shadows[5],
    minHeight: 'fit-content',
    indicator: {
      display: 'none',
    },
    height: 38,
    fontSize: 12,
    borderRadius: 'none', //20
    border: '1.5px solid #00c2ff', //newlyadded
    background: '#161c24',
    margin: 0, //5
    color: theme.palette.text.primary,
    '&:hover': {
      background: '#161c24',
    },
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '&:first-child': {
      borderRadius: '7px 0 0 7px',
      borderLeft: `1.5px solid ${theme.palette.primary.main}`,
    },
    '&:nth-child(2)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:nth-child(3)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:last-child': {
      borderRadius: '0 7px 7px 0',
      borderLeft: '0',
    },
  
    [theme.breakpoints.up('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: `0 !important`,
      minWidth: '30.33% !important',
    },
  }))
  const handleChangeSortJobs = (category) => {
    setSort(category);
    setSortOpen(false);
  };

  const handleByDue =()=>{
    setDueData(!dueData)
  }

  const toggleType = (typeId) => {
    setTypes((prev) => {
      const updated = prev.map((type) =>
        type.id === typeId ? { ...type, checked: !type.checked } : type
      );
      // Update selectedJobClassIdsString when types change
      const selectedIds = updated.filter(type => type.checked).map(type => type.id);
      setSelectedJobClassIdsString(selectedIds.join(','));
      return updated;
    });
  };
  const toggleCategory = (catId) => {
    setCategories((prev) => {
      const updated = prev.map((c) =>
        c.id === catId ? { ...c, checked: !c.checked } : c
      );
      // Update selectedJobTypesIdsString when categories change
      const selectedIds = updated.filter(cat => cat.checked).map(cat => cat.id);
      setSelectedJobTypesIdsString(selectedIds.join(','));
      return updated;
    });
  };

  const toggleCommunity = (commId) => {
    setCommunitiesData((prev) =>
      prev.map((c) =>
        c.id === commId ? { ...c, checked: !c.checked } : c
      )
    );
        // Then also manage the "filterCommunity" array
        setFilterCommunity((prev) => {
          const newFilter = prev.includes(commId)
            ? prev.filter((id) => id !== commId) // remove
            : [...prev, commId]; // add
          return newFilter;
        });
      };
      
      const toggleDepartment = (depId) => {
        setDepartmentsData((prev) =>
          prev.map((c) =>
            c.id === depId ? { ...c, checked: !c.checked } : c
          )
        );
            // Then also manage the "filterDepartment" array
            setFilterDepartment((prev) => {
              const newFilter = prev.includes(depId)
                ? prev.filter((id) => id !== depId) // remove
                : [...prev, depId]; // add
              return newFilter;
            });
       };

      const toggleClient = (commId) => {
        setClientData((prev) =>
          prev.map((c) =>
            c.id === commId ? { ...c, checked: !c.checked } : c
          )
        );
            // Then also manage the "filterCommunity" array
            setFilterClient((prev) =>
              prev.includes(commId)
                ? prev.filter((id) => id !== commId) // remove
                : [...prev, commId] // add
            );
      };

      const toggleUser = (userId) => {
        setUserData((prev) =>
          prev.map((u) =>
            u.id === userId ? { ...u, checked: !u.checked } : u
          )
        );
        // Then also manage the "filterUser" array
        setFilterUser((prev) =>
          prev.includes(userId)
            ? prev.filter((id) => id !== userId) // remove
            : [...prev, userId] // add
        );
      };

  const wordCount = filterName?.trim().split(/\s+/).filter(Boolean).length || 0;
  const isOverLimit = wordCount > 25;

  const handleFilterProjectType = (type) => {
    setFilterProjectType(type);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0); // Reset to first page when searching
  };

  const handleOpenFilters = (event) => {
    setFiltersAnchorEl(event.currentTarget);
  };

  const handleCloseFilters = () => {
    setFiltersAnchorEl(null);
    setClientOpen(false);
    setUsersOpen(false);
    setCommunitiesOpen(false);
    setDepartmentsOpen(false);
    setOpenType(false);
    setOpencategory(false);
    setSortOpen(false);
  };

  // Persist estimate-jobs filters to DB whenever they change (debounced 300ms)
  useEffect(() => {
    if (!filtersInitialized) return;

    // Skip calling update-project-filters once right after initial load
    if (!didRunInitialFiltersSyncRef.current) {
      didRunInitialFiltersSyncRef.current = true;
      return;
    }

    // While deleting filters, don't sync to backend
    if (isDeletingFilters) return;

    const currentUserId = user?.user_id;
    if (!currentUserId) return;

    const timeoutId = setTimeout(async () => {
      try {
        await axios.post(`${REST_API_END_POINT}update-project-filters`, {
          userId: currentUserId,
          clientFilter: filterClient || [],
          communityFilter: filterCommunity || [],
          userFilter: filterUser || [],
          teamFilter: filterDepartment || [],
          jobClassFilter: selectedJobClassIdsString
            ? selectedJobClassIdsString.split(',').map(id => parseInt(id)).filter(Boolean)
            : [],
          jobTypeFilter: selectedJobTypesIdsString
            ? selectedJobTypesIdsString.split(',').map(id => parseInt(id)).filter(Boolean)
            : [],
          projectTypeFilter: filterProjectType,
          dueFilter: dueData ? 1 : 0,
          sortFilter: sort?.id || (SORT[1]?.id || 'new'),
          fromDate: filterDateValue[0]
            ? Math.floor(new Date(filterDateValue[0]).getTime() / 1000)
            : null,
          toDate: filterDateValue[1]
            ? Math.floor(new Date(filterDateValue[1]).getTime() / 1000)
            : null,
          pageKey: 'estimate_jobs',
        });
        // setFiltersApplied(true);
      } catch (error) {
        console.error('Error saving estimate-jobs filters:', error);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    filterClient,
    filterUser,
    filterCommunity,
    filterDepartment,
    filterProjectType,
    dueData,
    sort,
    filterDateValue,
    selectedJobClassIdsString,
    selectedJobTypesIdsString,
    filtersInitialized,
  ]);

  // Load saved estimate-jobs filters from DB on mount
  useEffect(() => {
    const loadSavedEstimateJobsFilters = async () => {
      try {
        const currentUserId = user?.user_id;
        if (!currentUserId) return;

        const response = await axios.post(`${REST_API_END_POINT}get-project-filters`, {
          userId: currentUserId,
          pageKey: 'estimate_jobs',
        });

        if (response?.data?.status === 1 && response?.data?.data) {
          const saved = response.data.data;

          if (saved.filtersApplied) {
            setFiltersApplied(true);
          }

          // Date range (timestamps stored in seconds)
          setFilterDateValue([
            saved.fromDate ? new Date(saved.fromDate * 1000) : null,
            saved.toDate ? new Date(saved.toDate * 1000) : null,
          ]);

          // Project type filter
          if (saved.projectTypeFilter !== undefined && saved.projectTypeFilter !== null) {
            const rawType = saved.projectTypeFilter;
            if (rawType === 'ALL' || rawType === 'all') {
              setFilterProjectType('ALL');
            } else {
              const numericType = Number(rawType);
              setFilterProjectType(!Number.isNaN(numericType) ? numericType : 'ALL');
            }
          }

          // Due & sort
          setDueData(Number(saved.dueFilter) === 1);
          if (saved.sortFilter) {
            const matchedSort = SORT.find(item => item.id === saved.sortFilter);
            if (matchedSort) setSort(matchedSort);
          }

          // Client / user / community / department filters
          if (Array.isArray(saved.clientFilter)) {
            setFilterClient(saved.clientFilter);
          }
          if (Array.isArray(saved.userFilter)) {
            setFilterUser(saved.userFilter);
          }
          if (Array.isArray(saved.communityFilter)) {
            setFilterCommunity(saved.communityFilter);
          }
          if (Array.isArray(saved.teamFilter)) {
            setFilterDepartment(saved.teamFilter);
          }

          // Job class (types) filter
          if (Array.isArray(saved.jobClassFilter) && saved.jobClassFilter.length > 0) {
            const savedJobClassIds = saved.jobClassFilter.map(id => parseInt(id));
            setSelectedJobClassIdsString(savedJobClassIds.join(','));
            setTypes(prev =>
              prev.map(t => ({ ...t, checked: savedJobClassIds.includes(Number(t.id)) }))
            );
          }

          // Job type (categories) filter
          if (Array.isArray(saved.jobTypeFilter) && saved.jobTypeFilter.length > 0) {
            const savedJobTypeIds = saved.jobTypeFilter.map(id => parseInt(id));
            setSelectedJobTypesIdsString(savedJobTypeIds.join(','));
            setCategories(prev =>
              prev.map(c => ({ ...c, checked: savedJobTypeIds.includes(Number(c.id)) }))
            );
          }
        }
      } catch (error) {
        console.error('Error loading saved estimate-jobs filters:', error);
      } finally {
        setFiltersInitialized(true);
      }
    };

    loadSavedEstimateJobsFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteQuotationFilters = async () => {
    if (!userId || isDeletingFilters) return;

    setIsDeletingFilters(true);
    try {
      await axios.post(`${REST_API_END_POINT}delete-project-filters`, {
        userId,
        pageKey: 'estimate_jobs',
      });

      setFilterClient([]);
      setFilterUser([]);
      setFilterCommunity([]);
      setFilterProjectType('ALL');
      setDueData(true);
      setSort(SORT[0]);
      setFilterDateValue([null, null]);
      setPage(0);
      setFiltersApplied(false);
    } catch (error) {
      console.error('Error deleting quotation filters:', error);
    } finally {
      setIsDeletingFilters(false);
    }
  };

  return (
    <Page title={`Estimate Jobs | ${COMPANY_NAME}`}>
      <Container>
        <HeaderBreadcrumbs
          heading={'Estimate Jobs'}
          action={
            (!add && !isEdit) && (
              <Button
                ref={refSettings}
                onClick={handleOpenFilters}
                variant="contained"
                color="success"
                sx={{
                  color: 'common.white',
                  border: filtersApplied ? '2px solid rgb(255, 0, 0)' : '1px solid #00c2ff',
                }}
                startIcon={<FilterList />}
              >
                Filters
              </Button>
            )
          }
        />
        {!add && !isEdit && (
          <Popover
            open={isFiltersOpen}
            anchorEl={filtersAnchorEl}
            onClose={handleCloseFilters}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                width: { xs: '92vw', sm: 620, md: 780 },
                maxWidth: '92vw',
                p: 2,
              },
            }}
          >
            <Grid container spacing={2}>
              {!all && (
                <Grid item xs={12} sm={6}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="none"
                    aria-label="secondary tabs example"
                    sx={{ mb: { xs: 1, md: 0 } }}
                  >
                    <CustomTab value="one" icon={<ViewModule />} />
                    <CustomTab value="two" icon={<ViewList />} />
                    <CustomTab value="three" icon={<ListIcon />} />
                  </Tabs>
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <ButtonGroup variant="outlined" sx={{ width: '100%', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<Stack className='si--projects-alt-duotone' />}
                    variant={filterProjectType === 'ALL' ? 'contained' : 'outlined'}
                    sx={{ boxShadow: 'none' }}
                    onClick={() => handleFilterProjectType('ALL')}
                  >
                    All
                  </Button>
                  <Button
                    startIcon={<Stack className='carbon--traffic-flow' />}
                    variant={filterProjectType === 1 ? 'contained' : 'outlined'}
                    sx={{ boxShadow: 'none' }}
                    onClick={() => handleFilterProjectType(1)}
                  >
                    TS
                  </Button>
                  <Button
                    startIcon={<Stack className='fluent--production-checkmark-20-regular' />}
                    variant={filterProjectType === 2 ? 'contained' : 'outlined'}
                    sx={{ boxShadow: 'none' }}
                    onClick={() => handleFilterProjectType(2)}
                  >
                    PS
                  </Button>
                </ButtonGroup>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="flex-start">
                  <Button variant='outlined' 
                    sx={{height:'38px',backgroundColor: dueData?'#1ccaff' :'',color:dueData?"#fff":''}} 
                    onClick={handleByDue} endIcon={<Stack> {dueData ? <Visibility /> : <VisibilityOff/>} </Stack>}>
                    By Due
                  </Button>
                  <Stack>
                    <Button
                      ref={refSort}
                      onClick={() => setSortOpen((prevState) => !prevState)}
                      disabled={dueData}
                      variant="outlined"
                      type="button"
                      endIcon={
                        <Stack>
                          {sortOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                        </Stack>
                      }
                    >
                      {sort.label}
                    </Button>
                    {dueData && (
                      <FormHelperText sx={{ color: 'error.main', fontSize: '0.65rem', mt: 0.5 }}>
                        Disable "By Due" to enable this.
                      </FormHelperText>
                    )}
                    <Menu
                      open={Boolean(sortOpen)}
                      anchorEl={refSort.current}
                      onClose={() => setSortOpen(false)}
                      PaperProps={{
                        sx: { width: 'auto', maxWidth: '100%', maxHeight: '250px' },
                      }}
                      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                      {SORT.map((category) => (
                        <MenuItem key={category.id} onClick={() => handleChangeSortJobs(category)}>
                          <ListItemText primary={category.label} />
                        </MenuItem>
                      ))}
                    </Menu>
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MobileDateRangePicker
                  startText="Filter Date"
                  endText="Filter Date"
                  value={filterDateValue}
                  onChange={(newValue) => {
                    setFilterDateValue(newValue);
                  }}
                  renderInput={(startProps, endProps) => (
                    <>
                      <TextField {...startProps} sx={{ width: '100%' }} helperText='Filter By Due Date' label='From Date' size="small" InputLabelProps={{ style: { color: theme.palette.primary.main, borderColor: theme.palette.primary.main } }}/>
                      <Box sx={{ mx: 1, color: theme.palette.primary.main, display:'flex', alignItems:'center' }}> - </Box>
                      <TextField {...endProps} sx={{ width: '100%' }} helperText='' label='To Date' size="small" InputLabelProps={{ style: { color: theme.palette.primary.main, borderColor: theme.palette.primary.main } }}/>
                    </>
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {!all && (
                    <>
                      <Button ref={refClients} onClick={() => setClientOpen(prevState => !prevState)} 
                              variant="outlined"
                              type="submit"
                              endIcon={
                                <Stack>
                                  {clientOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                                </Stack>
                              }
                            >
                              Filter By Client
                      </Button>
                      <Menu
                        open={Boolean(clientOpen)}
                        anchorEl={refClients.current}
                        onClose={() => setClientOpen(false)}
                        PaperProps={{
                          sx: { width: 'auto', maxWidth: '100%', }
                        }}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      >
                        <Box sx={{ p: 2, pb: 1 }}>
                          <TextField
                            size="small"
                            placeholder="Search clients..."
                            value={clientSearchTerm}
                            onChange={(e) => setClientSearchTerm(e.target.value)}
                            fullWidth
                            variant="outlined"
                            sx={{ 
                              mb: 1,
                            }}
                          />
                          <Divider sx={{ mt: 1 }}/>
                        </Box>
                        <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {(() => {
                            const filteredClients = clientData?.filter((type) =>
                              type.name?.toLowerCase().includes(clientSearchTerm.toLowerCase())
                            ) || [];
                            
                            // Sort in strict alphanumeric order
                            const sortedClients = filteredClients.sort((a, b) => {
                              const nameA = (a.name || '').trim();
                              const nameB = (b.name || '').trim();
                              return nameA.localeCompare(nameB, undefined, { 
                                numeric: true, 
                                sensitivity: 'base' 
                              });
                            });
                            
                            if (sortedClients.length === 0 && clientSearchTerm) {
                              return (
                                <MenuItem disabled sx={{ justifyContent: 'center' }}>
                                  <ListItemText 
                                    primary="No result found" 
                                    sx={{ textAlign: 'center' }}
                                  />
                                </MenuItem>
                              );
                            }
                            
                            return sortedClients.map((type) => (
                              <MenuItem key={type.id} >
                                <Checkbox
                                  checked={filterClient.includes(type.id)}
                                  onChange={() => toggleClient(type.id)}
                                />
                                {type.id === 'other' ?
                                  <ListItemText primary={`${type.name}`} />
                                :
                                  <ListItemText primary={`${type.name}`} />
                                }
                              </MenuItem>
                            ));
                          })()}
                        </List>
                      </Menu>
                    </>
                  )}

                  {!all && (
                    <>
                      <Button ref={refUsers} onClick={() => setUsersOpen(prevState => !prevState)} 
                              variant="outlined"
                              type="submit"
                              endIcon={
                                <Stack>
                                  {usersOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                                </Stack>
                              }
                            >
                              Filter By User
                      </Button>
                      <Menu
                        open={Boolean(usersOpen)}
                        anchorEl={refUsers.current}
                        onClose={() => setUsersOpen(false)}
                        PaperProps={{
                          sx: { width: 'auto', maxWidth: '100%',  }
                        }}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      >
                        <Box sx={{ p: 2, pb: 1 }}>
                          <TextField
                            size="small"
                            placeholder="Search users..."
                            value={userSearchTerm}
                            onChange={(e) => setUserSearchTerm(e.target.value)}
                            fullWidth
                            variant="outlined"
                            sx={{ 
                              mb: 1,
                            }}
                          />
                          <Divider sx={{ mt: 1 }}/>
                        </Box>
                        <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {(() => {
                            const filteredUsers = userData?.filter((user) => {
                              const searchText = userSearchTerm.toLowerCase();
                              const userName = (user.userName || user.person_name || user.name || user.email || '').toLowerCase();
                              return userName.includes(searchText);
                            }) || [];
                            
                            // Sort in strict alphanumeric order
                            const sortedUsers = filteredUsers.sort((a, b) => {
                              const nameA = (a.userName || a.person_name || a.name || a.email || '').trim();
                              const nameB = (b.userName || b.person_name || b.name || b.email || '').trim();
                              return nameA.localeCompare(nameB, undefined, { 
                                numeric: true, 
                                sensitivity: 'base' 
                              });
                            });
                            
                            if (sortedUsers.length === 0 && userSearchTerm) {
                              return (
                                <MenuItem disabled sx={{ justifyContent: 'center' }}>
                                  <ListItemText 
                                    primary="No result found" 
                                    sx={{ textAlign: 'center' }}
                                  />
                                </MenuItem>
                              );
                            }
                            
                            return sortedUsers.map((user) => (
                              <MenuItem key={user.id} >
                                <Checkbox
                                  checked={filterUser.includes(user.id)}
                                  onChange={() => toggleUser(user.id)}
                                />
                                <ListItemText primary={`${user.userName || user.person_name || user.name || user.email}`} />
                              </MenuItem>
                            ));
                          })()}
                        </Box>
                      </Menu>
                    </>
                  )}
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {!all && (
                    <>
                      <Button ref={refCommunities} onClick={() => setCommunitiesOpen(prevState => !prevState)} 
                              variant="outlined"
                              type="submit"
                              endIcon={
                                <Stack>
                                  {communitiesOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                                </Stack>
                              }
                            >
                              Filter Project
                      </Button>
                      <Menu
                        open={Boolean(communitiesOpen)}
                        anchorEl={refCommunities.current}
                        onClose={() => setCommunitiesOpen(false)}
                        PaperProps={{
                          sx: { width: 'auto', maxWidth: '100%' }
                        }}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      >
                        <Box sx={{ p: 2, pb: 1 }}>
                          <TextField
                            size="small"
                            placeholder="Search projects..."
                            value={projectSearchTerm}
                            onChange={(e) => setProjectSearchTerm(e.target.value)}
                            fullWidth
                            variant="outlined"
                            sx={{ 
                              mb: 1,
                            }}
                          />
                          <Divider sx={{ mt: 1 }}/>
                        </Box>
                        <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {(() => {
                            const filteredProjects = communitiesData?.filter((type) =>
                              type.name?.toLowerCase().includes(projectSearchTerm.toLowerCase())
                            ) || [];
                            
                            // Sort in strict alphanumeric order
                            const sortedProjects = filteredProjects.sort((a, b) => {
                              const nameA = (a.name || '').trim();
                              const nameB = (b.name || '').trim();
                              return nameA.localeCompare(nameB, undefined, { 
                                numeric: true, 
                                sensitivity: 'base' 
                              });
                            });
                            
                            if (sortedProjects.length === 0 && projectSearchTerm) {
                              return (
                                <MenuItem disabled sx={{ justifyContent: 'center' }}>
                                  <ListItemText 
                                    primary="No result found" 
                                    sx={{ textAlign: 'center' }}
                                  />
                                </MenuItem>
                              );
                            }
                            
                            return sortedProjects.map((type) => (
                              <MenuItem key={type.id} >
                                <Checkbox
                                  checked={filterCommunity.includes(type.id)}
                                  onChange={() => toggleCommunity(type.id)}
                                />
                                {type.id === 'other' ?
                                  <ListItemText primary={`${type.name}`} />
                                :
                                  <ListItemText primary={`${type.name}`} />
                                  /* <ListItemText primary={`${type.name} (${type.no_of_projects})`} /> do not uncomment this the count is total not according to the tab*/ 
                                }
                              </MenuItem>
                            ));
                          })()}
                        </List>
                      </Menu>
                    </>
                  )}

                  {!all && (
                    <>
                      <Button ref={refDepartments} onClick={() => setDepartmentsOpen(prevState => !prevState)} 
                              variant="outlined"
                              type="submit"
                              endIcon={
                                <Stack>
                                  {departmentsOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                                </Stack>
                              }
                            >
                              Filter By Department
                      </Button>
                      <Menu
                        open={Boolean(departmentsOpen)}
                        anchorEl={refDepartments.current}
                        onClose={() => setDepartmentsOpen(false)}
                        PaperProps={{
                          sx: { width: 'auto', maxWidth: '100%' }
                        }}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      >
                        <Box sx={{ p: 2, pb: 1 }}>
                          <TextField
                            size="small"
                            placeholder="Search departments..."
                            value={departmentSearchTerm}
                            onChange={(e) => setDepartmentSearchTerm(e.target.value)}
                            fullWidth
                            variant="outlined"
                            sx={{ 
                              mb: 1,
                            }}
                          />
                          <Divider sx={{ mt: 1 }}/>
                        </Box>
                        <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {(() => {
                            const filteredDepartments = departmentsData?.filter((type) =>
                              type.name?.toLowerCase().includes(departmentSearchTerm.toLowerCase())
                            ) || [];
                            
                            // Sort in strict alphanumeric order
                            const sortedDepartments = filteredDepartments.sort((a, b) => {
                              const nameA = (a.name || '').trim();
                              const nameB = (b.name || '').trim();
                              return nameA.localeCompare(nameB, undefined, { 
                                numeric: true, 
                                sensitivity: 'base' 
                              });
                            });
                            
                            if (sortedDepartments.length === 0 && departmentSearchTerm) {
                              return (
                                <MenuItem disabled sx={{ justifyContent: 'center' }}>
                                  <ListItemText 
                                    primary="No result found" 
                                    sx={{ textAlign: 'center' }}
                                  />
                                </MenuItem>
                              );
                            }
                            
                            return sortedDepartments.map((type) => (
                              <MenuItem key={type.id} >
                                <Checkbox
                                  checked={filterDepartment.includes(type.id)}
                                  onChange={() => toggleDepartment(type.id)}
                                />
                                {type.id === 'All' ?
                                  <ListItemText primary={`${type.name}`} />
                                :
                                  <ListItemText primary={`${type.name}`} />
                                }
                              </MenuItem>
                            ));
                          })()}
                        </List>
                      </Menu>
                    </>
                  )}
                 
                </Stack>
              </Grid>
              {filtersApplied && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={deleteQuotationFilters}
                    disabled={isDeletingFilters}
                    startIcon={<Delete />}
                    sx={{ mt: 2, ml: 2 }}
                  >
                    {isDeletingFilters ? 'Resetting...' : 'Reset Filters'}
                  </Button>
                )}

              {!all && (filterCommunity.length > 0 || filterClient.length > 0 || filterUser.length > 0 || filterDepartment.length > 0) && (
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {filterCommunity.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          border: 1,
                          borderColor: 'primary.main',
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          maxWidth: '100%',
                          height: 70,
                          overflowY: 'auto',
                          overflowX: 'hidden',
                        }}
                      >
                        <span style={{ color: theme.palette.primary.darker, marginRight: 8, whiteSpace: 'nowrap' }}>
                          Selected Projects
                        </span>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {communitiesData
                            .filter(community => filterCommunity.includes(community.id))
                            .map(community => (
                              <Chip
                                key={community.id}
                                label={community.name}
                                size="small"
                                onDelete={() => toggleCommunity(community.id)}
                              />
                            ))}
                        </Box>
                      </Box>
                    )}
                    {filterClient.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          border: 1,
                          borderColor: 'primary.main',
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          maxWidth: '100%',
                          height: 70,
                          overflowY: 'auto',
                          overflowX: 'hidden',
                        }}
                      >
                        <span style={{ color: theme.palette.primary.darker, marginRight: 8, whiteSpace: 'nowrap' }}>
                          Selected Clients
                        </span>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {clientData
                            .filter(client => filterClient.includes(client.id))
                            .map(client => (
                              <Chip
                                key={client.id}
                                label={client.name}
                                size="small"
                                onDelete={() => toggleClient(client.id)}
                              />
                            ))}
                        </Box>
                      </Box>
                    )}
                    {filterUser.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          border: 1,
                          borderColor: 'primary.main',
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          maxWidth: '100%',
                          height: 70,
                          overflowY: 'auto',
                          overflowX: 'hidden',
                        }}
                      >
                        <span style={{ color: theme.palette.primary.darker, marginRight: 8, whiteSpace: 'nowrap' }}>
                          Selected Users
                        </span>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {userData
                            .filter(user => filterUser.includes(user.id))
                            .map(user => (
                              <Chip
                                key={user.id}
                                label={user.userName || user.person_name || user.name || user.email}
                                size="small"
                                onDelete={() => toggleUser(user.id)}
                              />
                            ))}
                        </Box>
                      </Box>
                    )}
                    {filterDepartment.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          border: 1,
                          borderColor: 'primary.main',
                          borderRadius: 2,
                          px: 1,
                          py: 0.5,
                          maxWidth: '100%',
                          height: 70,
                          overflowY: 'auto',
                          overflowX: 'hidden',
                        }}
                      >
                        <span style={{ color: theme.palette.primary?.darker, marginRight: 8, whiteSpace: 'nowrap' }}>
                          Selected Departments
                        </span>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {departmentsData
                            .filter(department => filterDepartment?.includes(department.id))
                            .map(department => (
                              <Chip
                                key={department.id}
                                label={department.name}
                                size="small"
                                onDelete={() => toggleDepartment(department.id)}
                              />
                            ))}
                        </Box>
                      </Box>
                    )}
                  </Stack>
                </Grid>
              )}
            </Grid>
          </Popover>
        )}

        {(!add && !isEdit ) ?
        (<>
          {!add && !isEdit && (
            <Box sx={{ mt: -4, mb: 3 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <SearchStyle
                  sx={{ backgroundColor: 'var(--signwise-app-chrome-toolbar)', height: 40, 
                    ...(isOverLimit && {
                      '& fieldset': {
                        borderColor: theme.palette.error.main + ' !important'
                      }
                    })
                  }}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder={`Search Estimate Jobs`}
                  startAdornment={
                    <InputAdornment position="start">
                      <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                    </InputAdornment>
                  }
                />
                {isOverLimit && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    Maximum 25 words allowed.
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        {all ?(
        <Scrollbar>
          {/* NEW: Pagination implementation for All Jobs */}
          {isLoading ? (
            SkeletonLoad
          ) : (
            <Grid container spacing={3}>
              {data?.map((post, index) => {
                const nameMatch = filterName
                  ? (
                    post.name?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post.description?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post.customer_name?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post.job_category_name?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post.job_class_name?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post.community_name?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post.doc_number?.toLowerCase().includes(filterName.toLowerCase()) ||
                    post?.est_doc_number?.toLowerCase().includes(filterName.toLowerCase())
                  )
                  : true;
                  if(!nameMatch){
                    return null;
                  }
                return (
                // <BlogPostCard key={post.id} post={post} index={index} />
                <Grid key={index} item xs={12} sm={6} md={4}>
                <UserCard medal={post.status === 0 || post.status === 1 ? '/static/icons/super.png' : post.status !== 0 && post.status !== 1 && post.status !== 3 ? '/static/icons/great.png' : '/static/icons/regular.png'} handleFetchEditData={handleFetchEditData} setIsEdit={setIsEdit} user={post}  />
              </Grid>
              )})}
            </Grid>
          )}
          
          {/* Pagination Component for All Jobs */}
          <Stack gap={2} sx={{ mt: 2, width: '100%', alignItems: 'flex-start' }}>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[25, 50, 100, 500]}
              labelRowsPerPage="Rows per page:"
              labelDisplayedRows={({ from, to, count }) => 
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
              sx={({
                width: '100%',
                color: theme.palette.mode === 'dark' ? '#fff' : '#000',
            
                '& .MuiTablePagination-selectLabel': {
                  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                },
                '& .MuiTablePagination-displayedRows': {
                  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                },
                '& .MuiTablePagination-select': {
                  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                },
                '& .MuiTablePagination-selectIcon': {
                  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                },
                '& .MuiIconButton-root': {
                  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                },
              })}
            />
          </Stack>
        </Scrollbar>
          ):(
        <Scrollbar>
            {/* <Stack sx={{ alignItems: { lg:'center',md:'center' } }} spacing={5}> */}
            <Grid container spacing={2} >
            <Tabs
              value={currentTab}
              scrollButtons="auto"
              variant="scrollable"
              allowScrollButtonsMobile
              onChange={handleChangeTab}   
              sx={{mb:2.5}}      
            >
              {ACCOUNT_TABS.map((tab) => (
                <Tab  sx={{
                  justifyContent: 'center', 
                  marginX: 6, 
                  mt: 2.5,
                  overflow:'visible'
                }}
                disableRipple
                key={tab.value}
                label={
                //  <Badge badgeContent={tab.count} color="warning" max={9999} showZero>
                    <Typography variant="overline">{tab.label || tab.value}</Typography>
                // </Badge>
                }
                icon={tab.icon}
                value={tab.value}
              />
              ))}
            </Tabs>
  
            {ACCOUNT_TABS.map((tab) => {
            const isMatched = tab.value === currentTab;
  
        return isMatched && value === 'one' ?
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
              {tab.component}
          </Box>
          : (isMatched && value === 'three') ?
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
                  {tab.listComponent}
              </Box>
              : (isMatched && value === 'two') ?
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
                 {tab.GridListComponent}
              </Box> : '';
            })}
            
            {/* Pagination Component */}
            <Stack gap={2} sx={{ mt: 2, width: '100%', alignItems: 'flex-start' }}>
              <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[25, 50, 100, 500]}
                labelRowsPerPage="Rows per page:"
                labelDisplayedRows={({ from, to, count }) => 
                  `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
                }
                sx={({
                  width: '100%',
                  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
              
                  '& .MuiTablePagination-selectLabel': {
                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                  },
                  '& .MuiTablePagination-displayedRows': {
                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                  },
                  '& .MuiTablePagination-select': {
                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                  },
                  '& .MuiTablePagination-selectIcon': {
                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                  },
                  '& .MuiIconButton-root': {
                    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                  },
                })}
              />
            </Stack>
   </Grid>
          {/* </Stack> */}
        </Scrollbar>
        )}
        
        </>
        ):(
          <AddProject singleProjectData={isEdit ? singleProjectData : null} setRenderCards={setRenderCards} isEdit={isEdit} setIsEdit={setIsEdit} setAdd={setAdd}/>
        )}
      </Container>
    </Page>
  );
}
